"use strict";

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
export const formatPhoneNumberNZ = (phoneNumber = '', addCountryCode = false) => {
  // Strip country code
  let trimmed = phoneNumber.replace(/^\+64/, '').trim();

  // Remove all non-numeric characters
  trimmed = trimmed.replace(/\D/g, '');

  // Add leading zero where needed
  if (trimmed[0] !== '0') {
    trimmed = `0${trimmed}`;
  }

  // Add spaces based on specific prefixes
  if (/^02/.test(trimmed)) {
    // Format mobile numbers
    trimmed = `${trimmed.slice(0, 3)} ${trimmed.slice(3, 6)} ${trimmed.slice(6)}`;
  } else if (/^(0800|0900|0508)/.test(trimmed)) {
    // Format toll-free numbers
    trimmed = `${trimmed.slice(0, 4)} ${trimmed.slice(4, 7)} ${trimmed.slice(7)}`;
  } else if (/^(03|04|06|07|09)/.test(trimmed)) {
    // Format landline numbers with area code
    trimmed = `${trimmed.slice(0, 2)} ${trimmed.slice(2, 5)} ${trimmed.slice(5)}`;
  } else {
    // Assume landline without area code
    trimmed = `${trimmed.slice(0, 3)} ${trimmed.slice(3)}`;
  }

  // Remove leading zero if country code is added
  if (addCountryCode && trimmed[0] === '0') {
    trimmed = trimmed.slice(1);
  }
  return (addCountryCode ? '(+64) ' : '') + trimmed;
};